import { css, injectGlobal } from "@emotion/css";

injectGlobal`
  @keyframes highlight-flash {
    0% { box-shadow: 0 0 0 4px #ffc107; }
    70% { box-shadow: 0 0 0 4px #ffc107; }
    100% { box-shadow: 0 0 0 0px #ffc107; }
  }
  .highlight-flash {
    animation: highlight-flash 2s ease-out;
  }
`;

export const editorStyles = {
  editorContainer: css`
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
  form: css`
    padding: 0 16px 16px;
    overflow-y: auto;
    flex: 1;
    background: #ececec;
  `,
  formPicking: css`
    position: relative;
    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: rgba(236, 236, 236, 0.8);
      z-index: 1;
      pointer-events: none;
    }
  `,
  toolbar: css`
    position: sticky;
    top: 0;
    z-index: 10;
    background: #ececec;
    padding: 8px 0;
  `,
  empty: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  pagePreview: css`
    padding: 8px;
    margin: 4px 0;
    background: #f5f5f5;
    border-radius: 4px;
  `,
  questionRef: css`
    padding: 8px;
    margin: 4px 0;
    background: #f5f5f5;
    border-radius: 4px;
  `,
  questionRefCard: css`
    margin-bottom: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #d1ecf1;
    padding: 8px;
  `,
  expandedSection: css`
    padding: 12px;
    margin-top: 8px;
    border-top: 1px solid #ddd;
    background: #f8f9fa;
  `,
  expandedSectionAlt: css`
    padding: 12px;
    margin-top: 8px;
    border-top: 1px solid #ddd;
    background: #f8f9fa;
  `,
  editorPageNav: css`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  `,
  editorPageNavButton: css`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background: #e0e0e0;
    color: #666;
    cursor: grab;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
      background: #bbdefb;
    }
  `,
  editorPageNavButtonActive: css`
    background: #2196f3;
    color: white;

    &:hover {
      background: #1976d2;
    }
  `,
  usageItem: css`
    padding: 12px;
    background: #f8f9fa;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      background: #e9ecef;
    }
  `,
};
